import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { ON_HOLD } from '../../../../services/api/order-status-from-view-service';
import Global from '../../../../store/global-selectors';
import { useFulfillmentPlanIdContext } from '../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useModal } from '../../../../hooks/use-modal';
import { RemoveHoldModal } from './remove-hold-modal';
import messages from './messages';

export const RemoveHoldButton = () => {
  const { open, isOpen, close } = useModal();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const fulfillmentPlanStatus =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanOrderGridStatus(state, {
        fulfillmentPlanId,
      }),
    ) ?? '';

  const hideButton = !fulfillmentPlanId || fulfillmentPlanStatus !== ON_HOLD;
  if (hideButton) {
    return null;
  }

  return (
    <>
      <Button onClick={open} theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...messages.removeHold} />
      </Button>
      {isOpen && <RemoveHoldModal fulfillmentPlanId={fulfillmentPlanId} onClose={close} />}
    </>
  );
};
